// extracted by mini-css-extract-plugin
export default {"brass-grid-edit-button":"EditCell_brass-grid-edit-button__rsNQb"};